import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const selectTriggerVariants = tv({
  base: `
    group flex min-w-0 border transition-[background-color,border-color,color,box-shadow]
    text-(--gray-text-2) outline-none rounded-md placeholder:text-(--gray-primary-1-alpha)
    aria-[disabled=true]:bg-(--gray-bg-2-alpha) aria-[readonly=true]:bg-(--gray-bg-2-alpha)
  `,
  variants: {
    size: {
      sm: "px-1",
      default: "px-2 py-1",
      lg: "px-2 py-1"
    },
    focus: { default: void 0, focus: void 0 },
    variant: {
      default: `
        bg-(--white) border-(--gray-tag-3-alpha) aria-invalid:border-(--red-6-alpha)
               focus:border-(--border-3-alpha)         focus:ring-(--border-1-alpha)        focus:ring-[1px]
        data-[focus]:border-(--border-3-alpha)  data-[focus]:ring-(--border-1-alpha) data-[focus]:ring-[1px] 
               aria-invalid:focus:border-(--red-6-alpha)         aria-invalid:focus:ring-(--red-3-alpha)
        aria-invalid:data-[focus]:border-(--red-6-alpha)  aria-invalid:data-[focus]:ring-(--red-3-alpha)
      `,
      filled: `
        border-transparent bg-(--tag-1-alpha) aria-invalid:bg-(--red-3-alpha)
                     hover:bg-(--tag-2-alpha)              focus:bg-(--tag-3-alpha)              data-[focus]:bg-(--tag-3-alpha)
        aria-invalid:hover:bg-(--red-4-alpha) aria-invalid:focus:bg-(--red-5-alpha) aria-invalid:data-[focus]:bg-(--red-5-alpha)
      `,
      ghost: `
        border-transparent
                     hover:bg-(--tag-1-alpha)              focus:bg-(--tag-2-alpha)              data-[focus]:bg-(--tag-2-alpha)
        aria-invalid:hover:bg-(--red-3-alpha) aria-invalid:focus:bg-(--red-4-alpha) aria-invalid:data-[focus]:bg-(--red-4-alpha)
      `
    },
    multiple: { default: void 0, multiple: void 0 }
  },
  compoundVariants: [
    { size: "sm", multiple: "default", class: "h-6" },
    { size: "default", multiple: "default", class: "h-9" },
    { size: "lg", multiple: "default", class: "h-10" },
    { size: "sm", multiple: "multiple", class: "min-h-6" },
    { size: "default", multiple: "multiple", class: "min-h-9" },
    { size: "lg", multiple: "multiple", class: "min-h-10" }
  ],
  defaultVariants: {
    size: "default",
    focus: "default",
    variant: "default",
    multiple: "default"
  }
}), selectTriggerLayoutVariants = tv({
  slots: {
    // 定义trigger内部的容器
    container: "w-full",
    // 定义prefix和suffix的布局
    fixWrapper: void 0
  },
  variants: {
    size: { sm: {}, default: {}, lg: {} }
  },
  compoundSlots: [
    { slots: ["container", "fixWrapper"], class: "flex rtl:flex-row-reverse items-center" },
    { slots: ["container", "fixWrapper"], size: "sm", class: "gap-1" },
    { slots: ["container", "fixWrapper"], size: ["default", "lg"], class: "gap-2" }
  ],
  defaultVariants: {
    size: "default"
  }
}), selectValueVariants = tv({
  base: "relative block size-full content-center rtl:text-right data-[placeholder]:truncate",
  slots: {
    // 定义多选时，tag的样式
    tag: "group-aria-invalid:bg-(--red-3-alpha) group-aria-invalid:text-(--red-11)",
    // 定义文字的颜色
    text: "group-aria-invalid:text-(--red-12)"
  },
  variants: {
    size: {
      sm: { text: "text-sm" },
      default: { text: "text-base" },
      lg: { text: "text-lg" }
    },
    disabled: {
      false: { text: "text-(--gray-text-2) data-[placeholder]:text-(--gray-primary-2-alpha)" },
      true: { text: "text-(--gray-border-3-alpha)" }
    },
    isHideOverflowingTagsShowAtLeastOne: {
      false: { tag: "shrink-0" },
      true: { tag: "grow shrink [&_svg]:shrink-0" }
    }
  },
  defaultVariants: {
    size: "default",
    disabled: !1,
    isHideOverflowingTagsShowAtLeastOne: !1
  }
}), selectSugarCoatingVariants = tv({
  base: "flex rtl:flex-row-reverse size-full",
  variants: {
    size: {
      sm: "gap-0.5",
      default: "gap-1",
      lg: "gap-1"
    },
    detachedFlow: {
      false: "flex-wrap",
      true: "absolute z-1 top-0 left-0 right-0 bottom-0 flex-nowrap"
    }
  },
  defaultVariants: {
    size: "default",
    detachedFlow: !1
  }
}), selectLabelVariants = tv({
  base: "font-semibold text-(--gray-primary-1) text-sm rtl:text-right",
  variants: {
    size: {
      sm: "py-0.5 px-1",
      default: "px-2 py-1.5",
      lg: "px-2 py-1.5"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), selectContentVariants = tv({
  base: `
    relative z-50 max-h-(--reka-select-content-available-height) min-w-[8rem] bg-(--white) border border-(--gray-tag-1)
    overflow-x-hidden overflow-y-auto rounded-md shadow-md
    data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95
    data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95
    data-[side=top]:slide-in-from-bottom-2 data-[side=right]:slide-in-from-left-2 data-[side=bottom]:slide-in-from-top-2
    data-[side=left]:slide-in-from-right-2
  `,
  variants: {
    position: {
      default: "",
      popper: "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1"
    }
  },
  defaultVariants: {
    position: "popper"
  }
}), selectContentViewportVariants = tv({
  variants: {
    position: {
      default: "",
      popper: "h-(--reka-select-trigger-height) w-full min-w-(--reka-select-trigger-width) scroll-my-1"
    }
  },
  defaultVariants: {
    position: "popper"
  }
}), selectItemVariants = tv({
  base: `
    relative flex rtl:flex-row-reverse w-full items-center text-sm cursor-default outline-hidden select-none
    text-(--gray-text-2) data-[disabled]:pointer-events-none data-[disabled]:text-(--gray-border-3-alpha)
    focus:bg-(--gray-tag-1) data-[state=checked]:font-semibold data-[state=checked]:bg-(--tag-2-alpha)
    [&_svg]:pointer-events-none
  `,
  variants: {
    size: {
      sm: "py-0.5 px-1 gap-1",
      default: "py-1.5 px-2 gap-2",
      lg: "py-1.5 px-2 gap-2"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
export {
  selectContentVariants,
  selectContentViewportVariants,
  selectItemVariants,
  selectLabelVariants,
  selectSugarCoatingVariants,
  selectTriggerLayoutVariants,
  selectTriggerVariants,
  selectValueVariants
};
//# sourceMappingURL=index.js.map
